import isElementFocusable from '../isElementFocusable';
import isElementHidden from '../isElementHidden';

var isElementTabbable = function isElementTabbable(element) {
  return isElementFocusable(element) && !isElementHidden(element);
};

export default isElementTabbable;